<template>
  <div>
    <div>
      <div class="a-tab__title-block">
        <h3>{{$t('form.lot.parts-and-payments')}}</h3>
      </div>
    </div>
    <section v-maximizable>
      <div class="table-tab table-tab--th-row-none">
<!--      <div class="admin-buy__block-gui-btn a-flex-start u-margin-b-24">-->
<!--        <button class="gui-btn gui-btn&#45;&#45;red u-margin-left-auto" type="button" @click.prevent="onDownloadPaymentsClick">-->
<!--          {{$t('buttons.download-payments-table')}}-->
<!--        </button>-->
<!--        <file-picker :label="'buttons.upload-payments-table'"-->
<!--                     accept="csv"-->
<!--                     :signing="false"-->
<!--                     @prepared="onFileSelected"-->
<!--                     v-if="canEditTable">-->
<!--        </file-picker>-->
<!--      </div>-->
      <div class="table-tab__container" style="overflow-x: auto">
        <table class="table-tab__block table" style="min-width: 1800px">
          <thead class="table-tab__thead">
            <tr class="">
              <th class="table-tab__border-bottom table-tab__th--row table-tab__border-right" colspan="2">{{$t('form.lot.payments.total')}}</th>

              <th class="table-tab__border-bottom" colspan="4">
              </th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.date-of-fixing-price-in-contract-currency')}}
              </th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.date-of-contract-signing-for-very-part')}}
              </th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.delivery-time')}}
                <!-- меняется пользователем -->
              </th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.delivery-date')}}
                <!--только текстовое поле part.deliveryDate-->
              </th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.accepting-quality-date')}}
                <br>
                {{$t('form.lot.payments.accepting-segment-date')}}
                <!--только текстовое поле part.receiveDate-->
              </th>
            </tr>
          </thead>
          <tbody class="table-tab__tbody">
            <template v-for="(part, partIdx) in parts">
              <tr>
                <th class=" table-tab__th--row table-tab__border-bottom table-tab__border-right table-tab__btn-open" colspan="2">
                  <img src="@/assets/img/static/arrow-vector.png" alt="">
                  <span class="u-padding-left-30">{{$t('form.lot.payments.total-part', {id: part.partId})}}</span>
                </th>

                <td colspan="4"></td>

                <td class="font-italic table-tab__width-180" style="font-size: 10px">
                  {{$t('form.lot.will-be-automatically-determined-in-bid')}}
                </td>

                <td class="font-italic table-tab__width-180" style="font-size: 10px">
                  {{$t('form.lot.will-be-automatically-determined-in-bid')}}
                </td>

                <td>
                  <div class="a-input-group" v-if="canEditPaymentsDays(part.partId)">
                    <input-number :value="part.paymentDays.value"
                                  @change="value => part.paymentDays.value = value"
                                  :disabled="!canEditTable"></input-number>
                    <dropdown-new class="select-w-95"
                                  :options="enums.Precision.options.all"
                                  :disabled="!canEditTable"
                                  v-model="part.paymentDays.precision">
                    </dropdown-new>
                  </div>
                  <label v-else>{{$t('form.lot.not-needed')}}</label>
                </td>

                <td>
                  <div class="a-input-group" v-if="canEditDays(part)">
                    <date-picker v-model="part.deliveryDate.value" :disabled="!canEditTable"></date-picker>
                    <dropdown-new class="select-w-95"
                                  :options="enums.Precision.options.all"
                                  :disabled="!canEditTable"
                                  v-model="part.deliveryDate.precision"></dropdown-new>
                  </div>
                  <label v-else-if="showParticipantShouldDetermineTheDateMessage(part)">{{$t('form.lot.will-be-determined-by-participant')}}</label>
                  <label v-else-if="showOrgShouldSpecifyTheDateMessage(part)">{{$t('form.lot.will-be-specified-by-org-in-retend')}}</label>
                  <label v-else>
                    {{$t(part.deliveryDate.precision.label)}}
                    <date-time tag="span" :value="part.deliveryDate.value" :time="false"></date-time>
                  </label>
                </td>

                <td>
                  <div class="a-input-group" v-if="canEditDays(part)">
                    <date-time :value="part.receiveDate.value" :time="false" :disabled="!canEditTable"></date-time>
                    <dropdown-new class="select-w-95"
                                  :options="enums.Precision.options.all"
                                  :disabled="!canEditTable"
                                  v-model="part.receiveDate.precision"></dropdown-new>
                  </div>
                  <label v-else-if="showParticipantShouldDetermineTheDateMessage(part)">{{$t('form.lot.will-be-determined-by-participant')}}</label>
                  <label v-else-if="showOrgShouldSpecifyTheDateMessage(part)">{{$t('form.lot.will-be-specified-by-org-in-retend')}}</label>
                  <label v-else>
                    {{$t(part.receiveDate.precision.label)}}
                    <date-time tag="span" :value="part.receiveDate.value" :time="false"></date-time>
                  </label>
                </td>
              </tr>


              <tr class="table-tab__thead">
                <th></th>

                <th class="table-tab__th--row table-tab__border-right">
                  {{$t('form.lot.payments.payment')}}
                </th>

                <th class="table-tab__border-bottom">
                  {{$t('form.lot.payments.sum')}}
                </th>
                <th class="table-tab__border-bottom">
                  {{$t('form.lot.payments.bid-currency')}}
                </th>
                <th class="table-tab__border-bottom">
                  {{$t('form.lot.payments.contract-currency')}}
                </th>
                <th class="table-tab__border-bottom table-tab__border-right">
                  {{$t('form.lot.payments.currency-clause')}}
                </th>

                <th class="table-tab__border-bottom">
                  {{$t('form.lot.payments.payment-deadline')}}
                </th>

                <th class="table-tab__border-bottom">
                  {{$t('form.lot.payments.payment-size-in-percent')}}
                </th>

                <th class="table-tab__border-bottom">
                  {{$t('form.lot.payments.payment-size-in-bid-currency')}}
                </th>

                <th class="table-tab__border-bottom">
                  {{$t('form.lot.payments.date-of-fixing-price')}}
                </th>
                <th class="table-tab__border-bottom"></th>
              </tr>

              <template v-for="(payment, paymentIdx) in part.payments">
                <tr>
                  <td class="table-tab__width-90"></td>

                  <td class=" table-tab__th--row table-tab__border-right"
                      v-if="payment.type === 'contract'">
                    {{$t('form.lot.payments.prepayment')}} №{{payment.num}}
                    <br/>
                    <i><small>{{$t('form.lot.payments.from-date-of-contract-conclusion')}}</small></i>
                  </td>
                  <td class=" table-tab__th--row table-tab__border-right"
                      v-else-if="payment.type === 'delivery'">
                    {{$t('form.lot.payments.payment')}} №{{payment.num}}
                    <br/>
                    <i><small>{{$t('form.lot.payments.from-date-of-delivery-of-part')}}</small></i>
                  </td>
                  <td class=" table-tab__th--row table-tab__border-right"
                      v-else-if="payment.type === 'accept'">
                    {{$t('form.lot.payments.payment')}} №{{payment.num}}
                    <br/>
                    <i><small>{{$t('form.lot.payments.from-date-of-quality-accepting')}}</small></i>
                  </td>

                  <td colspan="4" class="font-italic table-tab__width-180 table-tab__border-right text-center" style="font-size: 10px">
                    {{$t('form.lot.will-be-automatically-determined-in-bid')}}
                  </td>

                  <td v-if="payment.isBlocked">
                    Запрещен
                  </td>
                  <td v-else>
                    <div class="a-input-group">
                      <div class="a-form-field">
                        <input-number :value="payment.days.value"
                                      :disabled="!canEditTable"
                                      @change="onPaymentDaysChanged($event, 'value', partIdx, paymentIdx)"></input-number>
                        <span class="a-helper-text" v-if="payment.days.isFilled">
                        {{$t(getDaysLimitText(payment))}} {{payment.days.value}}
                        </span>
                      </div>
                      <dropdown-new class="select-w-95"
                                    :options="enums.Precision.options.all"
                                    :disabled="!canEditTable"
                                    :value="payment.days.precision"
                                    @change="onPaymentDaysChanged($event, 'precision', partIdx, paymentIdx)"></dropdown-new>
                    </div>
                  </td>

                  <td v-if="payment.isBlocked">
                    Запрещен
                  </td>
                  <td v-else>
                    <div class="a-form-field">
                      <div class="a-input-group">
                        <div :class="{'a-form-field--error':!isValidPercent(partIdx, paymentIdx)}">
                          <input-percent :value="payment.percent.value"
                                         :disabled="!canEditTable"
                                         @change="onPaymentPercentChanged($event, 'value', partIdx, paymentIdx)"></input-percent>
                          <span class="a-helper-text" v-if="payment.percent.isFilled">
                            {{$t(getPercentLimitText(payment))}} {{payment.percent.value|percent}}%
                          </span>
                        </div>
                        <dropdown-new class="select-w-95"
                                      :options="enums.Precision.options.all"
                                      :disabled="!canEditTable"
                                      :value="payment.percent.precision"
                                      @change="onPaymentPercentChanged($event, 'precision', partIdx, paymentIdx)"></dropdown-new>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    </section>
  </div>
</template>

<script>
  import { between } from '@/validators'
  import CommonMixins from '../mixins/common'
  import PermissionsMixins from '../mixins/permissions'
  import _ from "lodash";

  export default {
    props: {
      lot: Object
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    data: () => ({
      unwatch: undefined,
      parts: []
    }),

    computed: {
      canEditTable() {
        return this.canEditFull || this.canEditPartially;
      },
    },

    mounted() {
      this.$v.$touch();
    },

    watch: {
      'lot.parts': {
        deep: true,
        immediate: true,
        handler(value) {
          if (this.unwatch) this.unwatch();
          this.parts = _.cloneDeep(value);

          this.unwatch = this.$watch('parts', () => {
            //if (this.$v.$invalid) return;
            this.lot.parts = _.cloneDeep(this.parts);
          }, {deep: true})
        }
      }
    },

    validations: {
      parts: {
        $each: {
          payments: {
            validPercents(payments) {
              let total = 0;
              let allExact = true;

              for (const payment of payments) {
                const exactly = payment.percent.precision.valueOf() == this.enums.Precision.EXACTLY
                allExact &= exactly;
                if (payment.type !== 'contract' || exactly) {
                  total += payment.percent.value || 0;
                }
              }

              return allExact && total === 10000 || !allExact && total <= 10000;
            },
            $each: {
              percent: {
                value: {
                  validPercent: between(0, 10000)
                }
              }
            }
          }
        }
      }
    },

    methods: {
      canEditPaymentsDays(partId) {
        return !this.lot.dates[partId - 1];
      },

      canEditDays(part) {
        // we found there is not case when org can change days
        return false;
        //return this.lot.checkDates[part.partId - 1] && !this.lot.dates[part.partId - 1];
      },

      showParticipantShouldDetermineTheDateMessage(part) {
        return this.lot.checkDates[part.partId - 1] && !this.lot.dates[part.partId - 1];
      },

      showOrgShouldSpecifyTheDateMessage(part) {
        return !this.lot.checkDates[part.partId - 1] && !this.lot.dates[part.partId - 1];
      },

      isValidDuration(partIndex, paymentIndex) {
        const field = this.$v.parts.$each[partIndex].payments.$each[paymentIndex].duration;
        return field.$dirty && !field.validDuration;
      },

      isValidPercent(partIndex, paymentIndex) {
        const field = this.$v.parts.$each[partIndex].payments.$each[paymentIndex].percent.value;
        const payments = this.$v.parts.$each[partIndex].payments;

        return (!field.$dirty || field.validPercent) && (!payments.$dirty || payments.validPercents);
      },

      onAmountChanged(payment, part) {
        payment.percent = part.cost ? 10000 * payment.amount / part.cost: undefined;
      },

      onPaymentDaysChanged(value, field, partIdx, paymentIdx) {
        if (this.parts[partIdx].payments[paymentIdx].days[field].valueOf() === value) return;

        this.parts[partIdx].payments[paymentIdx].days[field] = value;

        for (const rule of this.lot.schedule.paymentTypes) {
          if (rule.fromPart === partIdx + 1) {
            for (let part = rule.fromPart + 1; part <= rule.toPart; ++part) {
              this.parts[part - 1].payments[paymentIdx].days[field] = this.parts[partIdx].payments[paymentIdx].days[field];
            }
          }
        }
      },

      onPaymentPercentChanged(value, field, partIdx, paymentIdx) {
        if (this.parts[partIdx].payments[paymentIdx].percent[field].valueOf() === value) return;

        this.parts[partIdx].payments[paymentIdx].percent[field] = value;

        for (const rule of this.lot.schedule.paymentTypes) {
          if (rule.fromPart === partIdx + 1) {
            for (let part = rule.fromPart + 1; part <= rule.toPart; ++part) {
              this.parts[part - 1].payments[paymentIdx].percent[field] = this.parts[partIdx].payments[paymentIdx].percent[field];
            }
          }
        }
      },

      async onDownloadPaymentsClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('exportBidPayments', {
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              filename: `${this.lot.catalog.name}-${this.lot.request.id}-${this.bid.num}-payments`
            });
          }
          catch(e) {
            console.error('failed download of bid payments', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onFileSelected(file) {
        try {
          await this.$store.dispatch('uploadBidPayments', {
            lotId: this.lot.id,
            requestId: this.lot.request.id,
            bidId: this.bid.id,
            file
          });

          await this.saveForm();
        }
        catch(e) {
          console.error('failed upload of bid payments', e);
          this.globalErrorHandler(e);
        }
      },

      getDaysLimitText(payment) {
        if (payment.days.precision.valueOf() === this.enums.Precision.NOT_WORSE) {
          return 'precision.not-less';
        }

        return payment.days.precision.label;
      },

      getPercentLimitText(payment) {
        if (payment.percent.precision.valueOf() === this.enums.Precision.NOT_WORSE) {
          if (payment.type !== 'contract' && payment.type === payment.lastPayment.type && payment.num === payment.lastPayment.num) {
            return 'precision.not-less';
          }
          return 'precision.not-more';
        }

        return payment.percent.precision.label;
      },
    }
  }
</script>

<style scoped>

</style>
